import { createTeamResourceContext } from './createTeamResourceContext'
import useHetznerProjectsResources from '../shared/resources/api/v1/cloud/useHetznerProjectsResources'

const { Provider: HetznerProjectsProvider, useHook: useHetznerProjects, useSafeHook: useHetznerProjectsSafe } = createTeamResourceContext({
  name: 'HetznerProjects',
  useResources: useHetznerProjectsResources,
  responseKey: 'projects',
  lookups: [
    { key: 'hetznerProjectsById', field: 'id' },
    { key: 'hetznerProjectsBySlug', field: 'slug' },
  ],
})

export { HetznerProjectsProvider, useHetznerProjects, useHetznerProjectsSafe }
